import React from 'react';

import ImgHtml from '../ImgHTML';
import img from '../../../assets/resources/pages/how-we-do/ourworkflow_dots.svg';

export default ({ staticContent: { title, description } }) => {
  return (
    <div className="container">
      <div className="">
        <div className="step first">
          <div className="left-section">
            <div className="number-border">
              <div className="number-step">
                <span>1</span>
              </div>
            </div>
          </div>
          <div className="right-section">
            <div className="content">
              <div className="row">
                <div className="col-md-6">
                  <h3 className="tt">{title}</h3>
                  <p>{description}</p>
                </div>
                <div className="col-md-6">
                  <ImgHtml className="step-img" src={img} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
